<template>
  <div class="withdraw-deposit" v-title data-title="积分提现">
    <!-- <header>
      <img src="../../assets/images/pay-img/pay-record-img/icon-24-fanhui.png" alt="" @click="back"> 
      <p>
        提现申请
      </p>
    </header> -->
    <section>
      <div class="withdraw-deposit-msg">
        <div class="sum">
          请输入提现积分金额：<input type="number" placeholder="请输入提现金额" v-model="money"> 
        </div>
        <div class="remaining-sum">
          您的账户可用积分为：<span>{{remaining_sum}}</span> 
        </div>
        <p class="idcard-msg">
          银行卡信息
        </p>
        <input type="text" placeholder="请输入开户行信息" v-model="bank" class="ip">
        <input type="number" placeholder="请输入银行卡号" v-model="card_no" class="ip">
        <input type="text" placeholder="请输入持卡人姓名" v-model="name" class="ip">
        <div class="apply" @click="applyBtn">
          申请提现
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

export default {
  data(){
    return{
      remaining_sum: '', //余额
      money: '', //金额
      bank: '', // 开户行信息
      card_no: '',// 银行卡号
      name: '', // 姓名
      uid : ""
    }
  },
  created(){

    this.uid = JSON.parse(localStorage.getItem("uid"));

    // 查询积分
    this.$axios.post(this.domain.url+"/api/score/index/sele_score?uid=" + this.uid).then((res) => {
      // console.log(res.data)
      this.remaining_sum = res.data
    })
  },
  methods:{
    // 路由返回
    back(){
      this.$router.push({
        path: '/pay-record',
        query:{
          active : 2
        }
      })
    },
    // 提交
    applyBtn(){
      let params = {
        uid : this.uid,
        score : this.money,
        bank_account : this.bank,
        bank_card : this.card_no,
        bank_name : this.name
      }
      // console.log(this.money,this.remaining_sum)
      if(Number(this.money) > Number(this.remaining_sum)){
        Toast('积分不足')
      } else if (!params.score) {
        Toast('请输入提现积分金额')
      } else if (!params.bank_account) {
        Toast('请输入开户行信息')
      } else if (!params.bank_card) {
        Toast('请输入银行卡号')
      } else if (!params.bank_name) {
        Toast('请输入持卡人姓名')
      } else {
        this.$axios.get('http://members.kfm666666.net/api/score/withdraw/withdraw',{params}).then(res => {
          console.log(res)
          if (res.data.code == 3) {
            Toast(res.data.msg)
            this.$router.push({
              path: '/my-jifen',
            })
          } else {
            Toast(res.data.msg)
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .withdraw-deposit{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: .01rem #E4E4E4 solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      overflow: scroll;
      flex: 1;
      // 提现
      .withdraw-deposit-msg{
        width: 6.4rem;
        margin: 0 auto;
        // 金额
        .sum,.remaining-sum,.idcard-msg{
          font-size: 0.28rem;
          line-height: .28rem;
          font-family: Source Han Sans CN Regular;
          font-weight: 400;
          color: #333333;
          letter-spacing: 0.02rem;
          input{
            width: 40%;
            border: none;
            outline: none;
          }
        }
        .sum{
          margin-top: .3rem;
        }
        // 余额
        .remaining-sum{
          margin-top: .4rem;
          span{
            color: #FF0000;
          }
        }
        // 标题
        .idcard-msg{
          margin-top: .4rem;
        }
        // 银行卡信息
        .ip{
          width: 6.1rem;
          height: .84rem;
          border: .01rem #cccccc   solid;
          border-radius: .1rem;
          margin-top: .34rem;
          padding-left: .3rem;
        }
        // 申请提现
        .apply{
          width: 6.4rem;
          height: 0.8rem;
          background: #ef8201;
          border-radius: .1rem;
          margin-top: .51rem;
          font-size: 0.28rem;
          font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          line-height: .8rem;
        }
      }
    }
  }
</style>